import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BonusCover } from './BonusCover';
import { Ornament } from './Ornament';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section id="bonos" className="bg-cream-deep text-ink" data-id="element-24" data-mp="avv308cxxatj">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-6 lg:py-24" data-id="element-25" data-mp="at8vg8q1uvbb">
        <div className="mx-auto max-w-2xl text-center" data-id="element-26" data-mp="fslesjhppk95">
          <p className="inline-flex items-center gap-2 font-sans text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-rose-deep" data-id="element-27" data-mp="1tvk1aid7wny">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-28" data-mp="5xjsdvetmwa9" />
            5 bonos de regalo
          </p>
          <h2 className="mt-3 font-display text-[1.9rem] font-semibold leading-[1.12] text-brown sm:text-[2.6rem]" style={{
          fontSize: "36px"
        }} data-id="element-29" data-mp="3o3fz62ow37ly">
            Y para acompañar tus 31 días, también te llevas todo esto gratis
          </h2>
          <p className="mt-4 font-sans text-[0.98rem] leading-relaxed text-ink-soft sm:text-[1.05rem]" data-id="element-30" data-mp="1r9l89ifsq54r">
            Creamos una colección de recursos para que tengas todo lo que necesitas para acompañar
            este camino.
          </p>
          <Ornament className="mt-7" data-id="element-31" data-mp="3df3cvwxibvnp" />
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:gap-8" data-id="element-32" data-mp="3r6zz5kchvbc6">
          {bonuses.map(bonus => <li key={bonus.title} className="flex flex-col items-center rounded-[28px] bg-white px-6 pb-7 pt-8 text-center ring-1 ring-gold/25 sm:flex-row sm:items-start sm:gap-6 sm:text-left md:flex-col md:items-center md:text-center lg:flex-row lg:items-start lg:text-left" data-id="element-33" data-mp="3n4mu6y5knhgg">
              <div className="relative w-44 flex-none sm:w-36 md:w-44 lg:w-40" data-id="element-34" data-mp="2uitwv431ov12">
                <BonusCover bonus={bonus} data-id="element-35" data-mp="38e5tjh0rgvkm" />
                <span className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-rose-deep px-3 py-1 font-sans text-[0.62rem] font-bold uppercase tracking-[0.14em] text-white shadow-sm" data-id="element-36" data-mp="33gntyh8mvspa">
                  Incluido gratis
                </span>
              </div>

              <div className="mt-8 flex min-w-0 flex-1 flex-col sm:mt-0 md:mt-8 lg:mt-0" data-id="element-37" data-mp="3cjfxf95ayjhc">
                <p className="font-sans text-[0.68rem] font-semibold uppercase tracking-[0.2em] text-gold-deep" data-id="element-38" data-mp="3hhr9lqj2l62q">
                  Bono gratis #{bonus.number}
                </p>
                <h3 className="mt-1.5 font-display text-[1.55rem] font-semibold leading-tight text-brown" data-id="element-39" data-mp="3lhrzc7bmd3p3">
                  {bonus.title}
                </h3>
                {bonus.highlight}
                <p className="mt-3 font-sans text-[0.95rem] leading-relaxed text-ink-soft" data-id="element-40" data-mp="2tqc4xr3tmcob">
                  {bonus.description}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}